module.exports = __webpack_public_path__ + "img/qywh-item-logo2.16a5b69f.png";